import { useMemo } from 'react';
import { createResourceAtom } from 'lib/atoms';
import { WellAllocationManagersResponse } from './types';

/**
 * Every unit agreement on a well, with its Allocation Manager, for the comparison view.
 *
 * The atom is recreated whenever the UWI changes so a different well fetches fresh —
 * `createResourceAtom` closes over its href.
 *
 * @param {string | null} wellUWI - Well to fetch agreements for; skips fetching when null.
 * @return {object} `{ loading, data }` where data is the response or `{ error }`.
 */
export const useWellAllocationManagersAtom = (wellUWI: string | null) =>
  useMemo(
    () =>
      createResourceAtom<WellAllocationManagersResponse>(
        wellUWI ? `/wells/${wellUWI}/allocation_managers` : undefined
      ),
    [wellUWI]
  );
